export default "__VITE_ASSET__wTS55PXs__"